<template>
  <div class="main_box">
    <h1 class="full_layout terms_title">Bid History</h1>
    <!-- 判读数据不能为空 -->
    <div class="full_layout bid_history_box" v-if="this.list != ''">
      <el-alert class="bidTips" :title="`Status for seller: Your item has been bid up to $ ${list.USD_Price}.`" type="success" show-icon :closable="false">
      </el-alert>
      <div class="contact_box like_box">
        <el-image class="like_img" fit="contain" :src="list.TitImg"></el-image>
        <div class="like_detail">
          <p>{{ list.Title }}</p>
        </div>
      </div>
      <div class="contact_box1">
        <div class="bid_history_info"><span class="m_16 text_gray">{{ list.Status != -2 ? 'Current bid:' : 'Winning bid:' }}</span>
          <div class="text_blue">$<em> {{ list.USD_Price }}</em></div>
        </div>
        <div class="bid_history_info"><span class="m_16 text_gray">ltem number:</span>{{ list.Code }}</div>
        <div class="bid_history_info_box">
          <div class="bid_history_info"><span class="text_gray">Bids:&nbsp;</span>{{ list.AuctionCount }}</div>
          <div class="bid_history_info"><span class="text_gray">Biders:&nbsp;</span>{{ list.AuctionsUserCount }}</div>
          <!-- 判断显示红色 -->
          <div class="bid_history_info"><span class="text_gray">Time left:&nbsp;</span><span :class="endingTime(list.EffectiveTime) < '00m 59s' ? 'text_red' : ''">{{ endingTime(list.EffectiveTime) }}</span></div>
          <div class="bid_history_info"><span class="text_gray">Duration:&nbsp;</span>{{ list.EffectiveDay }}
            {{ list.EffectiveDay > 1 ? 'Days' : 'Day' }}</div>
          <div class="bid_history_info"><span class="text_gray">Time Eeded:&nbsp;</span>{{ $store.getters.getTime(list.EffectiveTime) }}</div>
        </div>
        <!-- <el-button type="primary">Place bid</el-button> -->
      </div>
      <div class="bid_list_box">
        <!-- <div class="contact_box1">
          <router-link class="text_blue" :to="{path:'/mycardhoddy/bids'}">Learn more about bidding</router-link>
        </div> -->
        <div class="bid_list table_th_gray">
          <div>Bidder</div>
          <div>Bid Amount</div>
          <div>Bid Time</div>
        </div>
        <div class="bid_list" v-for="(item, index) in bidList" :key="index">
          <div><span>{{ item.CreateUserName }} ({{ item.BuyFavorableCount }})</span></div>
          <div>$ {{ item.USD_Price }}</div>
          <div>{{ item.CreateDate }}</div>
        </div>
      </div>
      <p class="text_gray" style="word-break: break-word;">Gray italic text indicates an automatic bid (proxy bid) placed by Card Hobby on
        behalf of the bidder. lf two people bid the sameamount, the first bid has priority. Trading cards are not eligible for bid
        retraction.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vctivehstory',
  data() {
    return {
      cid: '',
      list: '',
      bidList: '',
      isOK: false,
      timer: "",
      nowData: new Date().getTime(),
    }
  },
  filters: {},
  created() {
    this.cid = this.$route.params.id
    this.getDetail()
    this.cardTimer();
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    // 获取订单详情
    getDetail() {
      let that = this;
      that.$get('DetailCommodity', `?CommodityID=${this.cid}`)
        .then((res) => {
          if (res.result) {
            let result = res.data
            that.list = result
            that.bidList = result.Auctions;
            console.log(222, res.data)
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },
    endingTime(time) {
      let newval = this.$store.getters.cTime2CCT(this.nowData)
      return this.$store.getters.endingTime(newval, '', '', time)
    }
  }
}
</script>

<style>
@import "../../../static/css/vctivehstory.css";
</style>


// WEBPACK FOOTER //
// src/pages/commodity/vctivehstory.vue